import re from './re'
import el from './el'
import pwdStrengt from './pwdStrengt'
import checkLogin from './checkLogin'

export default {
  re,
  el,
  pwdStrengt,
  checkLogin,
}
